import {API_DOMAIN, API_KOTLIN_DOMAIN} from "../config"
import {fetchData, postData} from "../util"
import {http} from "../util/http"
import headers from "./employeeSystemHeader"

export const ClubChargeApi = {
    getClubCharge: async () => {
        const club = sessionStorage.getItem('club_id')
        const endpoint = `${API_DOMAIN}/Home/BossApi/SetCouponBalance/club_id/${club}`
        return await fetchData(endpoint)
    },

    getLevelList: async () => {
        const club = sessionStorage.getItem('club_id')
        const endpoint = `${API_DOMAIN}/Home/BossApi/GetAllLevel/club_id/${club}`
        return await fetchData(endpoint)
    },

    getPaymentList: async () => {
        const club = sessionStorage.getItem('club_id')
        const endpoint = `${API_DOMAIN}/Home/BossApi/PaymentTypeList/club_id/${club}`
        return await fetchData(endpoint)
    },

    getBaseTableList: async () => {
        return http({
            headers: headers(),
            url: `${API_KOTLIN_DOMAIN}/table/basic?clubId=${sessionStorage.getItem('club_id')}`,
        })
    },
    getChargeTableList: async (params) => {
        return http({
            headers: headers(),
            url: `${API_DOMAIN}/Home/BossApi/getCouponTable`,
            params,
        })
    },
    updateCharge: async (data) => {
        const endpoint = `${API_DOMAIN}/Home/BossApi/CouponBalanceOperate`
        return await postData(endpoint, 'POST', JSON.stringify(data))
    },

    deleteCharge: async (id) => {
        const endpoint = `${API_DOMAIN}/Home/BossApi/CouponBalanceDel/id/${id}`
        return await fetchData(endpoint)
    }

}


// WEBPACK FOOTER //
// ./src/api/clubChagre.js